import { Contact_Request } from "../models/Contact";
import { contact } from "../services/Contact";

export const PostContact = async (conatc: Contact_Request) => {
  console.log(conatc);
  const data = await contact.postContact(conatc);
  console.log(data);
};
